module.exports = __webpack_public_path__ + "static/media/gefactureerd.b951d475.svg";